module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs is-boxed is-centered"
  }, [_c('ul', _vm._l((_vm.tabs), function(tab) {
    return _c('router-link', {
      key: tab.to,
      staticClass: "is-size-5-tablet is-size-6-mobile",
      attrs: {
        "to": tab.to,
        "exact-active-class": "is-active",
        "tag": "li"
      }
    }, [_c('a', [_vm._v(_vm._s(tab.title) + " "), (tab.count) ? _c('span', {
      staticClass: "my-tag ml-1"
    }, [_vm._v(_vm._s(tab.count))]) : _vm._e()])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-04cff2da"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LinkTabs.vue
// module id = 971
// module chunks = 0